import { BACKEND_URL } from "../url/Url";

const VEHICULE_BASE = `${BACKEND_URL}/gestion-vehicule`;

const getAuthHeaders = () => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
};

const VehiculeService = {
  all: async () => {
    try {
      const response = await fetch(`${VEHICULE_BASE}/vehicules`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des véhicules', error);
      return { success: false, error: error.message };
    }
  },
  drivers: async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/drivers`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des véhicules', error);
      return { success: false, error: error.message };
    }
  }
};

export default VehiculeService;
